import React, { createContext, useContext, useState, useCallback } from "react";
import LeadDialog from "@/components/LeadDialog";

const LeadContext = createContext(null);

export const useLead = () => useContext(LeadContext);

export const LeadProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({ source: "book_inspection", title: "Book Your Free Inspection", prefill: {} });

  const openLead = useCallback((source = "book_inspection", opts = {}) => {
    const titles = {
      book_inspection: "Book Your Free Inspection",
      get_quote: "Get an Instant Quote",
      contact: "Send Us a Message",
      estimator: "Book Inspection",
    };
    setConfig({ source, title: opts.title || titles[source] || "Get in Touch", prefill: opts.prefill || {} });
    setOpen(true);
  }, []);

  return (
    <LeadContext.Provider value={{ openLead }}>
      {children}
      <LeadDialog open={open} onOpenChange={setOpen} config={config} />
    </LeadContext.Provider>
  );
};
